<template>
  <svg
    aria-hidden="true"
    tabindex="-1"
    role="presentation"
    class="icon icon-heart-full"
    viewBox="0 0 32 32"
  >
    <path
      d="M23,1.7c-1.7,0-3.5,0.6-5,1.8c-0.8,0.6-1.5,1.2-2,2c-0.5-0.7-1.2-1.4-2-2c-1.6-1.1-3.3-1.8-5-1.8c-5,0-9,4-9,9
	c0,11,15.3,19.5,15.4,19.6c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1C16.7,30.1,32,21.6,32,10.6C32,5.7,28,1.7,23,1.7z"
    />
  </svg>
</template>
<script>
export default {};
</script>
